import { useQuery } from '@tanstack/react-query';
import type { AgentApiProvidedJobPostTagsIndex } from '@/types/serializers';

/**
 * 求人タグ一覧を取得するフック
 */
export default function useJobPostTags() {
  return useQuery({
    queryKey: ['/agent/api/provided_job_post_tags'],
    queryFn: async () => {
      const response = await fetch('/agent/api/provided_job_post_tags', {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch job post tags');
      }

      const data: AgentApiProvidedJobPostTagsIndex = await response.json();
      return data;
    },
  });
}
